import { render } from "./AddUtrForm.vue?vue&type=template&id=4ddab17c&scoped=true"
import script from "./AddUtrForm.vue?vue&type=script&lang=js"
export * from "./AddUtrForm.vue?vue&type=script&lang=js"

import "./AddUtrForm.vue?vue&type=style&index=0&id=4ddab17c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddab17c"]])

export default __exports__